import { connect } from "scrivito"

import { FollowUpConfigurationAdminPage } from "./FollowUpConfigurationAdminPage"
import { useFollowUpConfigurationAdminPageModel } from "./model/useFollowUpConfigurationAdminPageModel"

function FollowUpConfigurationAdminPageConnectorComponent() {
  return (
    <FollowUpConfigurationAdminPage
      {...useFollowUpConfigurationAdminPageModel()}
    />
  )
}

export const FollowUpConfigurationAdminPageConnector = connect(
  FollowUpConfigurationAdminPageConnectorComponent
)
